import { API_BASE_URLS } from '../../../shared/constants/apiConstants';
import apiClient from '../../../shared/services/apiHelper';
import { validateResponse } from '../../../shared/utils/responseHelper';
import { getOuId, getUserData } from '../../../shared/utils/authStorage';
export const taskService = {
  // Fetch maintenance requests with filters
  fetchMaintenanceRequests: async (page = 1, filters = {},status) => {
    try {
      const queryParams = { page_number:page, };
      
      if (filters.sortField) {
        queryParams.sort = filters.sortField;
      }
     if(status!=null){
      queryParams.name=status;
     }
      // Build request data for POST requests with filters
      const requestBody = {
        wo_id:filters.searchQuery,
        scheduled_date: {
          from: filters.scheduledFromDate || null,
          to: filters.scheduledToDate || null
        },
        date_range: {
          from: filters.reportedFromDate || null,
          to: filters.reportedToDate || null
        },
        work_status: filters.selectedStatus || [],
        service_category: filters.selectedServiceCategories || [],
        priority: filters.selectedPriorities || [],
        client: filters.selectedClients || [],
        date_type: '',
        technician_list: filters.selectedEmployees || [],
        is_parent: true
      };

      // Add status filter if present
      if (filters.statusFilter) {
        requestBody.status = parseInt(filters.statusFilter);
      }

      // Check if we have any filters applied
      const hasFilters = 
        filters.selectedStatus?.length > 0 ||
        filters.selectedServiceCategories?.length > 0 ||
        filters.selectedPriorities?.length > 0 ||
        filters.selectedClients?.length > 0 ||
        filters.selectedEmployees?.length > 0 ||
        filters.reportedFromDate ||
        filters.reportedToDate ||
        filters.scheduledFromDate ||
        filters.scheduledToDate ||
        filters.searchQuery ||
        filters.statusFilter;
      const response = await apiClient.post('/task/search', requestBody, queryParams)
      const validatedResponse = validateResponse(response, 'Failed to fetch maintenance requests');
      // Return both validated data and headers for pagination
      return {
        ...validatedResponse,
        headers: response.headers
      };
    } catch (error) {
      console.error('Error fetching maintenance requests:', error);
      throw error;
    }
  },

  // Create new maintenance request
  createMaintenanceRequest: async (requestData) => {
    try {
      const response = await apiClient.post('/task', requestData);
      return validateResponse(response, 'Failed to create maintenance request');
    } catch (error) {
      console.error('Error creating maintenance request:', error);
      throw error;
    }
  },

  // Fetch equipment data
  fetchEquipment: async (name) => {
    const ouId = getOuId();
    try {
      const response = await apiClient.get(`task/equipments?ouId=${ouId}&name=${name}`);
      return validateResponse(response, 'Failed to fetch equipment');
    } catch (error) {
      console.error('Error fetching equipment:', error);
      throw error;
    }
  },

  // Search client addresses
  getSearchClientAddress: async (name = '') => {
    try {
      const userData = getUserData();
      const customerId = userData?.customer?.id;
      
      if (!customerId) {
        return [];
      }

      const response = await apiClient.get(`/client/address/${customerId}?search=${name}&expand=address.country`);
      
      if (response.data?.success) {
        return response.data.data || [];
      }
      return [];
    } catch (error) {
      console.error('TaskService - Address search error:', error);
      return [];
    }
  },

 
};